import { defaultStatus } from "../../screen/constant/defaultStatus";
import {
  PRODUCT_QUANTITY_ADD_REQUEST,
  PRODUCT_QUANTITY_ADD_SUCCESS,
  PRODUCT_QUANTITY_ADD_FAILURE,
  PRODUCT_QUANTITY_EDIT_REQUEST,
  PRODUCT_QUANTITY_EDIT_SUCCESS,
  PRODUCT_QUANTITY_EDIT_FAILURE,
  PRODUCT_QUANTITY_VIEW_REQUEST,
  PRODUCT_QUANTITY_VIEW_SUCCESS,
  PRODUCT_QUANTITY_VIEW_FAILURE,
  PRODUCT_QUANTITY_VIEW_ALL_REQUEST,
  PRODUCT_QUANTITY_VIEW_ALL_SUCCESS,
  PRODUCT_QUANTITY_VIEW_ALL_FAILURE,
  PRODUCT_QUANTITY_DELETE_REQUEST,
  PRODUCT_QUANTITY_DELETE_SUCCESS,
  PRODUCT_QUANTITY_DELETE_FAILURE,
  PRODUCT_QUANTITY_RESET_STATE,
  PRODUCT_QUANTITY_SEARCH_REQUEST,
  PRODUCT_QUANTITY_SEARCH_SUCCESS,
  PRODUCT_QUANTITY_SEARCH_FAILURE,
} from "./ProductQuantityTypes";

const initialState = {
  addProductQuantity: { ...defaultStatus },
  editProductQuantity: { ...defaultStatus },
  deleteProductQuantity: { ...defaultStatus },
  viewProductQuantity: { ...defaultStatus },
  viewAllProductQuantities: { ...defaultStatus },
  viewAllSearchProductQuantities: { ...defaultStatus },
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case PRODUCT_QUANTITY_ADD_REQUEST:
      return {
        ...state,
        addProductQuantity: { ...defaultStatus, inProgress: true, ...payload },
      };
    case PRODUCT_QUANTITY_ADD_SUCCESS:
      return {
        ...state,
        addProductQuantity: { ...defaultStatus, success: true, ...payload },
      };
    case PRODUCT_QUANTITY_ADD_FAILURE:
      return {
        ...state,
        addProductQuantity: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    case PRODUCT_QUANTITY_EDIT_REQUEST:
      return {
        ...state,
        editProductQuantity: { ...defaultStatus, inProgress: true, ...payload },
      };
    case PRODUCT_QUANTITY_EDIT_SUCCESS:
      return {
        ...state,
        editProductQuantity: { ...defaultStatus, success: true, ...payload },
      };
    case PRODUCT_QUANTITY_EDIT_FAILURE:
      return {
        ...state,
        editProductQuantity: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    case PRODUCT_QUANTITY_VIEW_REQUEST:
      return {
        ...state,
        viewProductQuantity: { ...defaultStatus, inProgress: true, ...payload },
      };
    case PRODUCT_QUANTITY_VIEW_SUCCESS:
      return {
        ...state,
        viewProductQuantity: { ...defaultStatus, success: true, ...payload },
      };
    case PRODUCT_QUANTITY_VIEW_FAILURE:
      return {
        ...state,
        viewProductQuantity: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    case PRODUCT_QUANTITY_VIEW_ALL_REQUEST:
      return {
        ...state,
        viewAllProductQuantities: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case PRODUCT_QUANTITY_VIEW_ALL_SUCCESS:
      return {
        ...state,
        viewAllProductQuantities: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case PRODUCT_QUANTITY_VIEW_ALL_FAILURE:
      return {
        ...state,
        viewAllProductQuantities: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    case PRODUCT_QUANTITY_SEARCH_REQUEST:
      return {
        ...state,
        viewAllSearchProductQuantities: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case PRODUCT_QUANTITY_SEARCH_SUCCESS:
      return {
        ...state,
        viewAllSearchProductQuantities: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case PRODUCT_QUANTITY_SEARCH_FAILURE:
      return {
        ...state,
        viewAllSearchProductQuantities: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    case PRODUCT_QUANTITY_DELETE_REQUEST:
      return {
        ...state,
        deleteProductQuantity: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case PRODUCT_QUANTITY_DELETE_SUCCESS:
      return {
        ...state,
        deleteProductQuantity: { ...defaultStatus, success: true, ...payload },
      };
    case PRODUCT_QUANTITY_DELETE_FAILURE:
      return {
        ...state,
        deleteProductQuantity: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    case PRODUCT_QUANTITY_RESET_STATE:
      return { ...initialState };

    default:
      return state;
  }
};

export default reducer;
